// extracted by mini-css-extract-plugin
export default {"bgSec":"#ebf0f2","fcQua":"#7bc0ff"};